import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ReactGA from 'react-ga4';
import withPageTransition from './withPageTransition';

import Espera from '../pages/Servicios/ProximasSoluciones/Espera';


import usePageTitle from './usePageTitle';

// import Home from '../pages/Inicio/Home';
// import About from '../pages/Nosotros/About';
// // import CAF from '../pages/CAF/CAF';
// import Proximamente from '../pages/Servicios/ProximasSoluciones/Proximamente';

// import FAQ from '../pages/FAQ/FAQ';
// import Insights from '../pages/Insights';
// import ArticleDetail from './Article/ArticleDetail';

// import SimulatorPage from '../pages/Servicios/Simulador/SimulatorPage';
// import GarantiaPlusPage from '../pages/Servicios/Garantia Plus/GarantiaPlus';
// import YourCreditPage from '../pages/Tu Credito/CreditForm2';
// // import FlexiCashPage from '../pages/Servicios/FlexiCash/FlexiCash';
// // import EmpleoCash from '../pages/Servicios/EmpleoCash/EmpleoCash';
// // import ProyectaPlusPage from '../pages/Servicios/Proyecta Plus/ProyectaPlus';
// import CashFlowPage from '../pages/Servicios/Cash Flow/CashFlow';
// import MetodologiaPage from '../pages/Metodología/Metodologia';
// import Acciones from '../pages/Nosotros/Acciones';
// import PrivacyPolicyModal from '../pages/avisoPrivacidad';
// import RedirectWithLoading from '../components/Comment/RedirectWithLoading';

const pages = [
  { path: '/', Component: Espera },
  { path: '/nosotros', Component: Espera },
  { path: '/metodologia', Component: Espera },
  { path: '/caf', Component: Espera },
  { path: '/faq',Component: Espera},
  { path: '/insights', Component: Espera },
  { path: '/acciones', Component: Espera },
  { path: '/insights/:articleId/:articleTitle', Component: Espera },
  { path: '*', Component: Espera },
  { path: '/unsubscribe/confirm/:token', Component: Espera },
  { path: '/soluciones/simulador', Component: Espera },
  { path: '/soluciones/garantia-plus', Component: Espera },
  { path: '/soluciones/garantia-plus', Component: Espera},
  { path: '/soluciones/flexicash', Component: Espera },
  { path: '/soluciones/empleocash', Component: Espera },
  { path: '/soluciones/proyecta-plus', Component: Espera },
  { path: '/soluciones/cash-flow', Component: Espera },
  { path: '/soluciones/proximas-soluciones', Component: Espera },
  { path: '/tu-credito', Component: Espera },
  { path: '/aviso-de-privacidad', Component: Espera }
  
  // { path: '/', Component: Home },
  // { path: '/nosotros', Component: About },
  // { path: '/metodologia', Component: MetodologiaPage },
  // { path: '/caf', Component: () => <RedirectWithLoading to="https://blog.piticcapital.com.mx/" delay={3000} /> },
  // { path: '/faq', Component: FAQ },
  // { path: '/insights', Component: Insights },
  // { path: '/acciones', Component: Acciones },
  // { path: '/insights/:articleId/:articleTitle', Component: ArticleDetail },
  // { path: '*', Component: NotFound },
  // { path: '/unsubscribe/confirm/:token', Component: Unsubscribe },
  // { path: '/soluciones/simulador', Component: SimulatorPage },
  // { path: '/soluciones/garantia-plus', Component: GarantiaPlusPage },
  // { path: '/soluciones/garantia-plus', Component: GarantiaPlusPage },
  // // { path: '/soluciones/flexicash', Component: FlexiCashPage },
  // // { path: '/soluciones/empleocash', Component: EmpleoCash },
  // // { path: '/soluciones/proyecta-plus', Component: ProyectaPlusPage },
  // { path: '/soluciones/cash-flow', Component: CashFlowPage },
  // { path: '/soluciones/proximas-soluciones', Component: Proximamente },
  // { path: '/tu-credito', Component: YourCreditPage },
  // { path: '/aviso-de-privacidad', Component: PrivacyPolicyModal }
];

/**
 * AnimatedRoutes component handles the routing for the application with animated transitions between routes.
 * It uses React Router for routing and Framer Motion for animations. It also integrates Google Analytics for page views tracking.
 *
 * @returns {JSX.Element} The rendered AnimatedRoutes component.
 */
const AnimatedRoutes: React.FC = () => {
  const location = useLocation();

  // Set the page title using a custom hook
  usePageTitle('Pitic Capital');

  // Track page views with Google Analytics
  useEffect(() => {
    const pagePath = location.pathname + location.search;
    ReactGA.send({ hitType: 'pageview', page: pagePath });
  }, [location]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {pages.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={React.createElement(withPageTransition(Component))}
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
